module.exports = __webpack_public_path__ + "static/media/logo.3513838b.png";